module.exports = __webpack_public_path__ + "img/ISO9001-en.dcbc28f0.png";